import {View} from "@lernetz/ts-lib";
import template from "./author-info.component.html";

export class AuthorCardView extends View {
    constructor() {
        super({ template });
    }
};
